export default __webpack_public_path__ + "static/media/checkbox-unchecked-yono.946f4275.png";